import { render, staticRenderFns } from "./DynamicContent.vue?vue&type=template&id=c6107ea0"
import script from "./DynamicContent.vue?vue&type=script&lang=js"
export * from "./DynamicContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports